import _ from 'lodash';
import TomSelect from 'tom-select';

const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

function focusSectionContent(section) {
	const focusable = section.querySelectorAll(FOCUSABLE_SELECTOR);
	for (const el of focusable) {
		if (!el.closest('.title-bar__actions')) {
			el.focus({ preventScroll: true });
			return;
		}
	}
	if (section.tabIndex < 0) section.tabIndex = -1;
	section.focus({ preventScroll: true });
}

/**
 * Initializes Tom Select for search-enabled select fields.
 */
const initSelect = function() {
	const selects = document.querySelectorAll('[data-tom-select]');
	if (!selects || selects.length < 1) return;

	const globalConfig = {
		selectOnTab: true,
		closeAfterSelect: true,
		maxItems: 1
	};

	const contentNavSelect = function(select, config) {
		config.maxOptions = false;
		config.onChange = function(value) {
			select.tomselect.setValue('', true);
			setTimeout(function() {
				const section = document.getElementById(value);
				if (section) {
					section.scrollIntoView({ behavior: 'smooth', block: 'start' });
					focusSectionContent(section);
				}
			}, 50);
		};
	};

	selects.forEach(function(select) {
		if (typeof select.tomselect !== 'undefined') return;
		const config = _.cloneDeep(globalConfig);
		if (select.dataset.contentNavSelect) contentNavSelect(select, config);
		new TomSelect(select, config);
	});
};

export default initSelect;


class SPFormSelect extends HTMLElement {
	connectedCallback() {
		this.select = this.querySelector('select');
		if (!this.select) return;

		if (this.select.dataset.tomSelect) this.initTomSelect();
	}

	get options() {
		if (!this.select) return [];

		const options = Array.from(this.select.options);
		return options.map(option => ({
			value: option.value,
			label: option.textContent
		}));
	}

	initTomSelect() {
		if (typeof this.select.tomselect !== 'undefined') return;

		this.config = {
			selectOnTab: true,
			closeAfterSelect: true,
			maxItems: 1
		};

		if (this.select.dataset.contentNavSelect) this.contentNavSelect();

		new TomSelect(this.select, this.config);
	}

	contentNavSelect() {
		const select = this.select;
		this.config.maxOptions = false;
		this.config.onChange = function(value) { 
			select.tomselect.setValue('', true);
			setTimeout(function() {
				const section = document.getElementById(value);
				if (section) {
					section.scrollIntoView({ behavior: 'smooth', block: 'start' });
					focusSectionContent(section);
				}
			}, 50);
		};
	}

	addOption(value, label) {
		if (!this.select) return;

		if (!label) label = value;

		const option = document.createElement('option');
		option.value = value;
		option.textContent = label;
		this.select.appendChild(option);

		if (this.select.tomselect) {
			this.select.tomselect.addOption({ value, text: label });
			this.select.tomselect.refreshOptions(false);
		}
	}

	addOptions(options) {
		if (!this.select || !Array.isArray(options)) return;

		options.forEach(option => {
			if (!option.value) return;
			this.addOption(option.value, option.label);
		});
	}

	removeOption(value) {
		if (!this.select) return;

		const option = this.select.querySelector(`option[value="${value}"]`);
		if (!option) return;

		option.remove();
		if (this.select.tomselect) {
			this.select.tomselect.removeOption(value);
			this.select.tomselect.refreshOptions(false);
		}
	}

	removeAllOptions() {
		if (!this.select) return;

		this.select.innerHTML = '';
		if (this.select.tomselect) {
			this.select.tomselect.clearOptions();
			this.select.tomselect.refreshOptions(false);
		}
	}

	getSelectedValues() {
		if (!this.select) return [];

		const selectedOptions = Array.from(this.select.selectedOptions);
		return selectedOptions.map(option => option.value);
	}

	clearSelected() {
		if (!this.select) return;

		this.select.selectedIndex = -1;
		if (this.select.tomselect) {
			this.select.tomselect.clear();
		}
	}
}
customElements.define('sp-form-select', SPFormSelect);